export default __webpack_public_path__ + "static/media/4-bg.23cce6d2.png";